 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Policy Status
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryPolStatFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs6>
                          <v-text-field
                            data-vv-scope="queryPolStatFilterForm"
                            v-model="filtersPolStat.polStat"
                            :label="filtersPolStatLabel.polStat"
                            :error-messages="errors.collect('polStat')"
                            data-vv-name="polStat"
                            :data-vv-as="filtersPolStatLabel.polStat"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearPolStatFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doPolStatFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="polStatHeaders"
          :items="polStatItems"
          v-bind:options.sync="paginationPolStat"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPolStat"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.polStat }}</td>
              <td>{{ row.item.polStatDesc }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignPolStat(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      filtersPolStatLabel: {
        polStat: 'Policy Status'
      },
      filtersPolStat: {
        polStat: undefined,
        defFilter: undefined
      },
      polStatItems: [],
      totalItemsPolStat: 0,
      polStatHeaders: [
        { text: 'Policy Status', align: 'left', value: 'polStat' },
        { text: 'Policy Status Description', value: 'polStatDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationPolStat: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doClearPolStatFilters()
      }
    },
    'paginationPolStat': function (value) {
      this.fetchPolStatData()
    }
  },
  mounted() {
    if (this.defFilter !== '' && this.defFilter === 'polAmend') {
      this.filtersPolStat.defFilter = this.defFilter
    }
    this.doClearPolStatFilters()
  },
  methods: {
    closeDialog() {
      this.resetFilterForm()
      this.$emit('close')
    },
    doClearPolStatFilters() {
      this.resetFilterForm()
      this.fetchPolStatData()
    },
    doPolStatFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryPolStatFilterForm').then((result) => {
        if (result) {
          this.paginationPolStat.page = 1
          this.fetchPolStatData()
        }
      })
    },
    assignPolStat(data) {
      this.$emit('assign-pol-stat-info', data)
      this.$emit('assign-pol-stat', data.polStat)
      this.$emit('close')
    },
    resetFilterForm() {
      this.filtersPolStat.polStat = ''
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    defFilter: {
      type: String,
      default: ''
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
